var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_54127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8.75C7.655 8.75 7.375 9.02978 7.375 9.375C7.375 9.71875 7.62813 10 8 10C8.37187 10 8.625 9.72016 8.625 9.375C8.625 9.00313 8.34375 8.75 8 8.75ZM14 0H2C0.898438 0 0 0.898438 0 1.97188V10.9438C0 12.1 0.898438 12.9719 2 12.9719H5V15.5688C5 15.8762 5.34469 16.0531 5.5975 15.8703L9.5 12.9719H14C15.1016 12.9719 16 12.0734 16 11V1.97188C16 0.898438 15.1031 0 14 0ZM15 11C15 11.55 14.55 12 14 12H9.49687C9.28037 12 9.06969 12.0703 8.89656 12.2002L6 14.375V12.5C6 12.2238 5.77613 12 5.5 12H2C1.45 12 1 11.55 1 11V2C1 1.45 1.45 1 2 1H14C14.55 1 15 1.45 15 2V11ZM8.69063 3H7.17812C6.25312 3 5.5 3.75313 5.5 4.675C5.5 4.95138 5.72363 5.175 6 5.175C6.27637 5.175 6.5 4.95138 6.5 4.675C6.5 4.30313 6.80312 4 7.17812 4H8.69281C9.1375 4 9.5 4.3625 9.5 4.80937C9.5 5.11797 9.32909 5.39531 9.04594 5.53656L7.76875 6.19688C7.60313 6.28438 7.5 6.45625 7.5 6.64063V7.5C7.5 7.775 7.725 8 8 8C8.275 8 8.5 7.77638 8.5 7.5V6.94688L9.5 6.42781C10.1172 6.11922 10.5 5.49781 10.5 4.80844C10.5 3.80937 9.6875 3 8.69063 3Z",
    fill: "#149CE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_54127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportThin);
export default __webpack_public_path__ + "static/media/support-thin.c471b5a8cb45c4764023b1390290435d.svg";
export { ForwardRef as ReactComponent };